import React from 'react';

const SectionHeader = ({ icon: Icon, title, className = '', children }) => (
  <div className={`flex items-center justify-between mb-2 ${className}`}>
    <div className='flex items-center gap-1'>
      {Icon && <Icon className='w-4 h-4 text-blue-500' />}
      <h2 className='text-lg font-bold text-gray-900 dark:text-white'>{title}</h2>
    </div>
    {children && <div>{children}</div>}
  </div>
);

export default SectionHeader; 